import React, { useEffect } from 'react'

import usePermission from '@/common/hooks/usePermission'

export function withPermissionGuard(
  Component,
  role: 'member' | 'owner' | 'broker'
) {
  function WithPermissionGuard(props) {
    const permission = usePermission()

    useEffect(() => {
      permission.guard(role)
    }, [permission])

    return permission.hasPermission(role) ? <Component {...props} /> : null
  }

  WithPermissionGuard.displayName = `withPermissionGuard(${
    Component.displayName ?? Component.name ?? 'Component'
  })`

  return WithPermissionGuard
}
